export const Languages = {
  en: 'English',
  tr: 'Türkçe',
};

export const LanguageKeys = Object.keys(Languages);
export const DefaultLanguage = LanguageKeys[0];
